import * as React from 'react';

// COMPONENTS
import Button from '../../components/Button';
import GlobalModal from '../../components/GlobalModal';
import RemoveModal from './RemoveModal';

// ICONS
import DisplayDragIcon from '../../components/DisplayDragIcon';

// TYPES
import { SafetyChecklistEditChecklistItem } from '../../api/models';

interface CheckListItemTypes {
	item: SafetyChecklistEditChecklistItem;
	index: number;
	renderedChecklistItems: SafetyChecklistEditChecklistItem[];
	setRenderedChecklistItems: React.Dispatch<React.SetStateAction<SafetyChecklistEditChecklistItem[]>>;
	removeHandler: (index: number) => void;
	onItemsChange?: () => void;
}

const CheckListItem: React.FC<CheckListItemTypes> = ({
	item,
	index,
	renderedChecklistItems,
	setRenderedChecklistItems,
	removeHandler,
	onItemsChange
}) => {
	const [showError, setShowError] = React.useState<boolean>(false);

	// State to control Modal
	const [showRemoveModal, setShowRemoveModal] = React.useState<boolean>(false);

	const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
		const { value } = e.target;

		let newData = [...renderedChecklistItems];

		newData[index].text = value;

		setRenderedChecklistItems(newData);
		onItemsChange?.();

		if (value === '') {
			setShowError(true);
		} else {
			setShowError(false);
		}
	};

	return (
		<div className="checklist-item-wrapper">
			<div className="checklist-item-container">
				<div className="item-detail">
					<input
						className="item-input"
						type="text"
						value={item.text || ''}
						onChange={(e) => onChangeHandler(e, index)}
					/>

					<DisplayDragIcon index={index} array={renderedChecklistItems} />
				</div>

				<div className="button-container">
					<Button className="btn-text" onClick={() => setShowRemoveModal(true)}>
						Remove
					</Button>
				</div>
			</div>

			{showError && <div className="error-message">This field can not be blank</div>}

			<GlobalModal isOpen={showRemoveModal} setIsOpen={setShowRemoveModal} titleText="Remove Checklist item">
				<RemoveModal removeHandler={removeHandler} index={index} />
			</GlobalModal>
		</div>
	);
};

export default CheckListItem;
